import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { stylingHelpers } from '../designTokens';
import { Image } from '../components';

const LogoList = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const LogoItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.spacings.kilo};
  max-height: 40px;
  width: calc(100% / 7);
`;

const { flexCenter } = stylingHelpers;

const Container = styled.div`
  width: 35px;
  height: 35px;
  margin: ${({ theme }) => theme.spacings.bit} ${({ theme }) => theme.spacings.byte};
  ${flexCenter()};
  svg {
    width: 35px;
    height: 35px;
  }
`;

const LogoImage = ({ src, alt }) => (
  <Container>
    <Image src={src} alt={alt} />
  </Container>
);

const TeamLogos = ({ cdnUrl, logos }) => (
  <LogoList>
    {Object.values(logos).map(({ filename, name }) => (
      <LogoItem key={name}>
        <LogoImage src={`${cdnUrl}${filename}`} alt={name} />
      </LogoItem>
    ))}
  </LogoList>
);

TeamLogos.propTypes = {
  cdnUrl: PropTypes.string,
  logos: PropTypes.object,
};

TeamLogos.defaultProps = {
  logos: {
    anaheim: {
      filename: 'anahiemducks2024.svg',
      name: 'Anaheim',
    },
    boston: {
      filename: 'boston_2025.svg',
      name: 'Boston',
    },
    buffalo: {
      filename: 'buffalo.svg',
      name: 'Buffalo',
    },
    calgary: {
      filename: 'calgary.svg',
      name: 'Calgary',
    },
    carolina: {
      filename: 'carolina.svg',
      name: 'Carolina',
    },
    chicago: {
      filename: 'chicago.svg',
      name: 'Chicago',
    },
    colorado: {
      filename: 'colorado.svg',
      name: 'Colorado',
    },
    columbus: {
      filename: 'columbus.svg',
      name: 'Columbus',
    },
    dallas: {
      filename: 'dallas.svg',
      name: 'Dallas',
    },
    detroit: {
      filename: 'detroit.svg',
      name: 'Detroit',
    },
    edmonton: {
      filename: 'edmonton.svg',
      name: 'Edmonton',
    },
    florida: {
      filename: 'florida.svg',
      name: 'Florida',
    },
    losAngeles: {
      filename: 'losangeleskings2024.svg',
      name: 'Los Angeles',
    },
    minnesota: {
      filename: 'minnesota.svg',
      name: 'Minnesota',
    },
    montreal: {
      filename: 'montreal.svg',
      name: 'Montreal',
    },
    nashville: {
      filename: 'nashville.svg',
      name: 'Nashville',
    },
    newJersey: {
      filename: 'newjersey.svg',
      name: 'New Jersey',
    },
    newYorkIslanders: {
      filename: 'ny_islanders.svg',
      name: 'NY Islanders',
    },
    newYorkRangers: {
      filename: 'ny_rangers.svg',
      name: 'NY Rangers',
    },
    ottawa: {
      filename: 'ottawa.svg',
      name: 'Ottawa',
    },
    philadelphia: {
      filename: 'philadelphia.svg',
      name: 'Philadelphia',
    },
    pittsburgh: {
      filename: 'pittsburghpenguins2024.svg',
      name: 'Pittsburgh',
    },
    sanJose: {
      filename: 'sanjose.svg',
      name: 'San Jose',
    },
    seattle: {
      filename: 'seattle.svg',
      name: 'Seattle',
    },
    stLouis: {
      filename: 'stlouis26.svg',
      name: 'St Louis',
    },
    tampaBay: {
      filename: 'tampabay.svg',
      name: 'Tampa Bay',
    },
    toronto: {
      filename: 'toronto.svg',
      name: 'Toronto',
    },
    utah: {
      filename: 'utahhc_2025.svg',
      name: 'Utah',
    },
    vancouver: {
      filename: 'vancouver.svg',
      name: 'Vancouver',
    },
    vegas: {
      filename: 'vegas.svg',
      name: 'Vegas',
    },
    washington: {
      filename: 'washington.svg',
      name: 'Washington',
    },
    winnipeg: {
      filename: 'winnipeg.svg',
      name: 'Winnipeg',
    },
  },
};

export default TeamLogos;
